import { useSiteCountryCode } from '@common/hooks/localisation';

export const useGetForgotPasswordLink = () => {
  const countryCode = useSiteCountryCode();

  return `/${countryCode}/forgot-password`;
};
